import React from 'react';
import { B } from '../constants';

export default function FlightWidget({ trip, onOpenFlightSearch }) {
  if (!trip?.destination) return null;

  const dest = trip.destination;
  const startDate = trip.startDate ? new Date(trip.startDate).toLocaleDateString() : '';
  const endDate = trip.endDate ? new Date(trip.endDate).toLocaleDateString() : '';

  return (
    <div
      style={{
        background: 'white',
        borderRadius: 16,
        padding: 20,
        marginBottom: 24,
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        flexWrap: 'wrap',
      }}
    >
      <div>
        <div style={{ fontWeight: 700, color: B.night, fontSize: 15, marginBottom: 4 }}>
          ✈️ Flights to {dest}
        </div>
        {startDate && (
          <div style={{ color: B.muted, fontSize: 13 }}>
            {startDate}{endDate ? ` – ${endDate}` : ''}
          </div>
        )}
      </div>
      <button
        type="button"
        onClick={onOpenFlightSearch}
        style={{
          background: B.forest,
          color: 'white',
          border: 'none',
          padding: '10px 20px',
          borderRadius: 10,
          cursor: 'pointer',
          fontWeight: 700,
          fontSize: 13,
          whiteSpace: 'nowrap',
        }}
      >
        Search Flights
      </button>
    </div>
  );
}
